import { UnknownAction, Reducer } from 'redux';
import { AppState } from './store';
import { setAuthTokenOnLogin } from '../auth/authReducer';

export const rootReducer: Reducer<AppState | undefined> = (state: AppState | undefined, action: UnknownAction) => {
  // Clear state on login or token switch
  if (action.type === (setAuthTokenOnLogin as any).type) {
    return undefined;
  }
  return state;
};
